import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminAuthGuardService as AdminCanActivate } from './auth/admin-auth-guard.service';
import { PatientAuthGuardService as PatientCanActivate } from './auth/patient-auth-guard.service';
import { NewAppointmentComponent } from './new-appointment/new-appointment.component';
import { PdfWorkerComponent } from './pdf-worker/pdf-worker.component';
const routes: Routes = [
  {
    path: "",
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },

  {
    path: "admin",
    canActivate:[AdminCanActivate],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: "patient",
    canActivate:[PatientCanActivate],
    loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule)
  },
  {
    path: "appointment",
    component: NewAppointmentComponent
  },
  {
    path: "pdf-worker",
    component: PdfWorkerComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
